import React from "react";
import PropTypes from "prop-types";
import Input from "../../simple/Input";
import SVG from "../../SVG";

import styles from "./search-input.module.scss";

const SearchInput = ({ value, name, handleChange }) => {
  return (
    <div className={styles["search-container"]}>
      <Input
        label=""
        containerClass={styles.search}
        inputClass={styles.input}
        placeholder="Search"
        handleChange={handleChange}
        name={name}
        value={value}
      />
      <SVG.HeaderSearchNew className={styles["search-icon"]} />
    </div>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func
};

SearchInput.defaultProps = {
  handleChange: () => {}
};

export default SearchInput;
